import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

/**
 * Events Service
 * Handles API calls for events management
 */

export const getAllEvents = async (page = 1, limit = 10, search = '', status = '', archived = false) => {
  try {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`${API_BASE_URL}/${routePath}/events`, {
      params: { page, limit, search, status, archived }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error fetching events' };
  }
};

export const toggleArchiveEvent = async (eventId) => {
  try {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.patch(`${API_BASE_URL}/${routePath}/events/${eventId}/archive`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error updating event' };
  }
};

export const getEventById = async (eventId) => {
  try {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`${API_BASE_URL}/${routePath}/events/${eventId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error fetching event' };
  }
};

export const createEvent = async (eventData) => {
  try {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(`${API_BASE_URL}/${routePath}/events`, eventData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error creating event' };
  }
};

export const updateEvent = async (eventId, eventData) => {
  try {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.put(`${API_BASE_URL}/${routePath}/events/${eventId}`, eventData);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error updating event' };
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.delete(`${API_BASE_URL}/${routePath}/events/${eventId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error deleting event' };
  }
};

export const getEventOptions = async () => {
  try {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`${API_BASE_URL}/${routePath}/events/options`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { success: false, message: 'Error fetching event options' };
  }
};

export default {
  getAllEvents,
  getEventById,
  createEvent,
  updateEvent,
  deleteEvent,
  toggleArchiveEvent,
  getEventOptions,
};
